import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
/** variable tag */
declare var gtag;
/** Componente app */
@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  /**
   * Constructor
   * @param router
   */
  constructor(private router: Router) {}

  /**
   * Inicializa el componente
   */
  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-7QMBW7SB6T', {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }
}
